/**
 * Si cambias algo aquí también cambiálo en backend/libs/canvas.settings.php
 */
export default {
    cellWidth   : 40,
    cellHeight  : 40,
    defaultSize : 3,
    defaultShape : [1,1], // 1 row, 1 col

    maxWidths: [
        [40,40],   // 1
        [80,80],   // 2
        [180,180], // 3
    ],

    //
    tileWidth   : 54.8,
    tileHeight  : 31.43
}



// WEBPACK FOOTER //
// ./src/CanvasSettings.js